import { createRouter, createWebHashHistory } from 'vue-router'

export const mainRoutes = {
  name: 'Main',
  component: () => import(/* webpackChunkName: "main" */ '@/views/Main'),
  children: [
    // 首頁
    {
      path: '/index',
      component: () =>
        import(/* webpackChunkName: "Index" */ '@/views/index/Index'),
      name: 'index',
      meta: { keepAlive: false },
    },
    {
      path: '/index-platform',
      component: () =>
        import(/* webpackChunkName: "Platform" */ '@/views/index/Platform'),
      name: 'index-platform',
      meta: { keepAlive: true },
    },
    // 我的帳戶
    {
      path: '/system-user-center',
      component: () =>
        import(
          /* webpackChunkName: "UserCenter" */ '@/views/system/UserCenter'
        ),
      name: 'system-user-center',
      meta: { keepAlive: true },
    },

    // 後台管理
    {
      path: '/staff-list',
      component: () =>
        import(/* webpackChunkName: "StaffList" */ '@/views/staff/StaffList'),
      name: 'staff-list',
      meta: { keepAlive: true },
    },
    {
      path: '/staff-auth',
      component: () =>
        import(/* webpackChunkName: "StaffAuth" */ '@/views/staff/StaffAuth'),
      name: 'staff-auth',
      meta: { keepAlive: true },
    },
    // 營運數據
    {
      path: '/operations-member-consume',
      component: () =>
        import(
          /* webpackChunkName: "OperationsMemberConsume" */ '@/views/operations/MemberConsume'
        ),
      name: 'operations-member-consume',
      meta: { keepAlive: true },
    },
    {
      path: '/operations-iap-order',
      component: () =>
        import(
          /* webpackChunkName: "OperationsIapOrder" */ '@/views/operations/IapOrder'
        ),
      name: 'operations-iap-order',
      meta: { keepAlive: true },
    },
    {
      path: '/operations-shop-order',
      component: () =>
        import(
          /* webpackChunkName: "OperationsShopOrder" */ '@/views/operations/ShopOrder'
        ),
      name: 'operations-shop-order',
      meta: { keepAlive: true },
    },
    // 會員管理
    {
      path: '/member-list',
      component: () =>
        import(
          /* webpackChunkName: "MemberList" */ '@/views/member/MemberList'
        ),
      name: 'member-list',
      meta: { keepAlive: true },
    },
    {
      path: '/member-punish',
      component: () =>
        import(
          /* webpackChunkName: "MemberPunish" */ '@/views/member/MemberPunish'
        ),
      name: 'member-punish',
      meta: { keepAlive: true },
    },
    {
      path: '/member-recharge',
      component: () =>
        import(
          /* webpackChunkName: "MemberRecharge" */ '@/views/member/MemberRecharge'
        ),
      name: 'member-recharge',
      meta: { keepAlive: true },
    },
    {
      path: '/member-blockade',
      component: () =>
        import(
          /* webpackChunkName: "MemberBlockade" */ '@/views/member/MemberBlockade'
        ),
      name: 'member-blockade',
      meta: { keepAlive: true },
    },
    // 代理管理
    {
      path: '/agent-list',
      component: () =>
        import(/* webpackChunkName: "AgentList" */ '@/views/agent/AgentList'),
      name: 'agent-list',
      // 標題與差額統計並排在頁面內,不顯示上方頁籤形狀的標題
      meta: { keepAlive: true, hideMainTitle: true },
    },
    {
      path: '/agent-setting',
      component: () =>
        import(
          /* webpackChunkName: "AgentSetting" */ '@/views/agent/AgentSetting'
        ),
      name: 'agent-setting',
      // 標題改為頁面內的標題框,不顯示上方頁籤形狀的標題
      meta: { keepAlive: true, hideMainTitle: true },
    },
    {
      path: '/agent-contribution-setting',
      component: () =>
        import(
          /* webpackChunkName: "AgentContributionSetting" */ '@/views/agent/AgentContributionSetting'
        ),
      name: 'agent-contribution-setting',
      meta: { keepAlive: true },
    },
    // APP管理
    {
      path: '/version-control',
      component: () =>
        import(
          /* webpackChunkName: "VersionControl" */ '@/views/version/VersionControl'
        ),
      name: 'version-control',
      meta: { keepAlive: true },
    },
    {
      path: '/version-maintain',
      component: () =>
        import(
          /* webpackChunkName: "VersionMaintain" */ '@/views/version/VersionMaintain'
        ),
      name: 'version-maintain',
      meta: { keepAlive: true },
    },
    // 審查功能
    {
      path: '/examine-device-info',
      component: () =>
        import(
          /* webpackChunkName: "ExamineDeviceInfo" */ '@/views/examine/ExamineDeviceInfo'
        ),
      name: 'examine-device-info',
      meta: { keepAlive: true },
    },
    {
      path: '/examine-table-info',
      component: () =>
        import(
          /* webpackChunkName: "ExamineTableInfo" */ '@/views/examine/ExamineTableInfo'
        ),
      name: 'examine-table-info',
      meta: { keepAlive: true },
    },
    {
      path: '/examine-replay',
      component: () =>
        import(
          /* webpackChunkName: "ExamineReplay" */ '@/views/examine/ExamineReplay'
        ),
      name: 'examine-replay',
      meta: { keepAlive: true },
    },
    // 資訊發佈
    {
      path: '/information-push',
      component: () =>
        import(
          /* webpackChunkName: "InformationPush" */ '@/views/information/InformationPush'
        ),
      name: 'information-push',
      meta: { keepAlive: true },
    },
    {
      path: '/information-marquee',
      component: () =>
        import(
          /* webpackChunkName: "InformationMarquee" */ '@/views/information/InformationMarquee'
        ),
      name: 'information-marquee',
      meta: { keepAlive: true },
    },
    {
      path: '/information-announcement',
      component: () =>
        import(
          /* webpackChunkName: "InformationAnnouncement" */ '@/views/information/InformationAnnouncement'
        ),
      name: 'information-announcement',
      meta: { keepAlive: true },
    },
    {
      path: '/information-promotional-event',
      component: () =>
        import(
          /* webpackChunkName: "InformationPromotionalEvent" */ '@/views/information/InformationPromotionalEvent'
        ),
      name: 'information-promotional-event',
      meta: { keepAlive: true },
    },
    {
      path: '/information-banner',
      component: () =>
        import(
          /* webpackChunkName: "InformationBanner" */ '@/views/information/InformationBanner'
        ),
      name: 'information-banner',
      meta: { keepAlive: true },
    },

    // 信件功能
    {
      path: '/internal-letter-list',
      component: () =>
        import(
          /* webpackChunkName: "InternalLetterList" */ '@/views/internalLetter/InternalLetterList'
        ),
      name: 'internal-letter-list',
      meta: { keepAlive: true },
    },
    {
      path: '/internal-letter-detail',
      component: () =>
        import(
          /* webpackChunkName: "InternalLetterDetail" */ '@/views/internalLetter/InternalLetterDetail'
        ),
      name: 'internal-letter-detail',
      meta: { keepAlive: true },
    },
    {
      path: '/internal-letter-template',
      component: () =>
        import(
          /* webpackChunkName: "InternalLetterTemplate" */ '@/views/internalLetter/InternalLetterTemplate'
        ),
      name: 'internal-letter-template',
      meta: { keepAlive: true },
    },

    // 遊戲設定
    {
      path: '/game-setting-buy-in',
      component: () =>
        import(
          /* webpackChunkName: "GameSettingBuyIn" */ '@/views/gameSetting/GameSettingBuyIn'
        ),
      name: 'game-setting-buy-in',
      meta: { keepAlive: true },
    },
    {
      path: '/game-setting-insurance-odds',
      component: () =>
        import(
          /* webpackChunkName: "GameSettingInsuranceOdds" */ '@/views/gameSetting/GameSettingInsuranceOdds'
        ),
      name: 'game-setting-insurance-odds',
      meta: { keepAlive: true },
    },
    {
      path: '/game-setting-red-envelope-pool',
      component: () =>
        import(
          /* webpackChunkName: "GameSettingRedEnvelopePool" */ '@/views/gameSetting/GameSettingRedEnvelopePool'
        ),
      name: 'game-setting-red-envelope-pool',
      meta: { keepAlive: true },
    },
    {
      path: '/game-setting-bad-beat-jackpot',
      component: () =>
        import(
          /* webpackChunkName: "GameSettingBadBeatJackpot" */ '@/views/gameSetting/GameSettingBadBeatJackpot'
        ),
      name: 'game-setting-bad-beat-jackpot',
      meta: { keepAlive: true },
    },
    // 公桌管理
    {
      path: '/public-table-list',
      component: () =>
        import(
          /* webpackChunkName: "PublicTableList" */ '@/views/publicTable/PublicTableList'
        ),
      name: 'public-table-list',
      meta: { keepAlive: true },
    },
    {
      path: '/public-table-template',
      component: () =>
        import(
          /* webpackChunkName: "PublicTableTemplate" */ '@/views/publicTable/PublicTableTemplate'
        ),
      name: 'public-table-template',
      meta: { keepAlive: true },
    },
    {
      path: '/public-table-bad-beat-jackpot',
      component: () =>
        import(
          /* webpackChunkName: "PublicTableBadBeatJackpot" */ '@/views/publicTable/PublicTableBadBeatJackpot'
        ),
      name: 'public-table-bad-beat-jackpot',
      meta: { keepAlive: true },
    },
    // 競技場管理
    {
      path: '/arena-list',
      component: () =>
        import(/* webpackChunkName: "ArenaList" */ '@/views/arena/ArenaList'),
      name: 'arena-list',
      meta: { keepAlive: true },
    },
    {
      path: '/arena-setting',
      component: () =>
        import(
          /* webpackChunkName: "ArenaSetting" */ '@/views/arena/ArenaSetting'
        ),
      name: 'arena-setting',
      meta: { keepAlive: true },
    },
    {
      path: '/arena-template',
      component: () =>
        import(
          /* webpackChunkName: "ArenaTemplate" */ '@/views/arena/ArenaTemplate'
        ),
      name: 'arena-template',
      meta: { keepAlive: true },
    },
    {
      path: '/arena-table-template',
      component: () =>
        import(
          /* webpackChunkName: "ArenaTableTemplate" */ '@/views/arena/ArenaTableTemplate'
        ),
      name: 'arena-table-template',
      meta: { keepAlive: true },
    },
    {
      path: '/arena-score-setting',
      component: () =>
        import(
          /* webpackChunkName: "ArenaScoreSetting" */ '@/views/arena/ArenaScoreSetting'
        ),
      name: 'arena-score-setting',
      meta: { keepAlive: true },
    },
    {
      path: '/arena-match-blind',
      component: () =>
        import(
          /* webpackChunkName: "ArenaMatchBlind" */ '@/views/arena/ArenaMatchBlind'
        ),
      name: 'arena-match-blind',
      meta: { keepAlive: true },
    },
    {
      path: '/arena-ledger-setting',
      component: () =>
        import(
          /* webpackChunkName: "ArenaLedgerSetting" */ '@/views/arena/ArenaLedgerSetting'
        ),
      name: 'arena-ledger-setting',
      meta: { keepAlive: true },
    },
    {
      path: '/arena-character-setting',
      component: () =>
        import(
          /* webpackChunkName: "ArenaCharacterSetting" */ '@/views/arena/ArenaCharacterSetting'
        ),
      name: 'arena-character-setting',
      meta: { keepAlive: true },
    },
    {
      path: '/arena-leaderboard',
      component: () =>
        import(
          /* webpackChunkName: "ArenaLeaderboard" */ '@/views/arena/ArenaLeaderboard'
        ),
      name: 'arena-leaderboard',
      meta: { keepAlive: true },
    },
  ],
  meta: {
    requiresAuth: true,
  },
}

export const routes = [
  {
    path: '/login',
    name: 'login',
    component: () =>
      import(/* webpackChunkName: "login" */ '@/views/Login.vue'),
  },
  mainRoutes,
]

export const router = createRouter({
  // history: createWebHistory(),
  history: createWebHashHistory(), // 使用 hash 模式
  routes,
})

router.beforeEach((to, from, next) => {
  const isAuthenticated = sessionStorage.getItem('token')
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!isAuthenticated) {
      next({ name: 'login' })
    } else {
      next()
    }
  } else {
    next()
  }
})
